import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInSuggestedFilterCountsExperiment() {
  const isHideCounts1Row = useIsInExperiment(
    'car-merch-ui-srp-suggested-filters',
    'hidecounts-1row'
  );
  const isHideCounts2Row = useIsInExperiment(
    'car-merch-ui-srp-suggested-filters',
    'hidecounts-2row'
  );

  return isHideCounts1Row || isHideCounts2Row;
}
